export default __webpack_public_path__ + "static/media/30g.20edfa89.svg";